import { Modal } from '~components/Modals/Base';
import type { TModalProps } from '~components/Modals/types';
import { Headline, Text } from '~components/Typography';
import { modal } from '~features/userInfo/ui/UserInfoModal/styles';
import { useTranslations } from '~i18n/hooks';
import Close from '~public/assets/icons/close.svg';
import { ButtonPrimary } from '~shared/ui/atoms/Buttons/ButtonPrimary';
import { ButtonSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary';

import { Actions, CloseButton, DeleteAccountContent, Spacer } from './styles';

export const DeleteAccountModal = ({
	open,
	locked,
	onClose,
	onConfirm,
	onCancel,
}: TModalProps & {
	onCancel?: () => void;
	onConfirm?: () => void;
}) => {
	const t = useTranslations('Auth.deleteAccountDialog');
	return (
		<Modal className={modal} open={open} locked={locked} onClose={onClose}>
			<Spacer />
			<DeleteAccountContent>
				<CloseButton
					type="button"
					size="M"
					leftIcon={<Close />}
					onClick={onClose}
				/>
				<Headline size="L">{t('titleV2')}</Headline>
				<Text size="M">{t('text')}</Text>
				<Actions>
					<ButtonSecondary type="button" onClick={onConfirm} size="M">
						{t('confirmButtonV2')}
					</ButtonSecondary>
					<ButtonPrimary type="button" onClick={onCancel} size="M">
						{t('cancelButton')}
					</ButtonPrimary>
				</Actions>
			</DeleteAccountContent>
			<Spacer />
		</Modal>
	);
};
